import {
  createPlugin,
  createRoutableExtension,
  createRouteRef
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'aws-ec2',
});

export const awsEc2Plugin = createPlugin({
  id: 'aws-ec2',
  routes: {
    root: rootRouteRef,
  },
});

export const AwsEc2Page = awsEc2Plugin.provide(
  createRoutableExtension({
    name: 'AwsEc2Page',
    component: () =>
      import('./components/awsec2dashboard').then(m => m.AwsEc2Dashboard),
    mountPoint: rootRouteRef,
  }),
);